import { VALIDATION_REGEX } from '~components/business-owner/customers/constants';

export const validateEmail = (emailStr: string) => VALIDATION_REGEX.email.test(emailStr);
